import React from "react";

const OfferButton = ({ text = "Explore More Offers", onClick }) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center gap-2 bg-[#181818] text-[#10FF9B] border border-[#10FF9B] px-3 py-3 rounded-md hover:bg-[#0e0e0e] transition-all duration-200"
    >
      <span className="text-base xs:text-xs">{text}</span>
      <img
        src="/assets/img/JBQxEg.png" // keep blank for now
        alt="icon"
        className="w-5 h-5 object-contain"
      />
    </button>
  );
};

export default OfferButton;
